// ═══════════════════════════════════════════════════════════════════════════
// La consola de plataforma, como aplicación aparte
//
// El operador: "Debe haber una página de administración independiente de
// Vinícola Total. Es otro nivel de la administración. Ahí podremos crear
// dueños, administrar el número de asientos y el tipo de suscripción."
//
// ── QUÉ SE SEPARA Y QUÉ NO ─────────────────────────────────────────────────
//
// Se separa el ORIGEN, no la base. La administración de plataforma administra
// INQUILINOS, y los inquilinos viven en la misma base que todo lo demás: una
// segunda base no podría verlos ni crearlos, duplicaría migraciones y
// respaldos, y sobre todo sería una segunda verdad sobre qué vinícolas
// existen — justo lo que este modelo evita en el saldo, las existencias y la
// cobranza, que se derivan y no se guardan dos veces.
//
// Además la capa de plataforma YA está en esta base: `platform_admin`,
// `es_super_admin()` y las 42 políticas que cuelgan de `mis_tenants()`.
// Partirla dejaría la consola sin poder usar nada de eso.
//
// Lo que sí se separa es el sitio, y eso es CLAUDE.md §5.1 al pie de la letra:
// aislamiento por origen —otro proyecto, otro dominio— nunca otra ruta del
// mismo. Se construye con su propia configuración (`vite.plataforma.config.js`)
// para que el paquete de la vinícola no cambie ni un byte.
//
// ── NO SE DUPLICA NADA ─────────────────────────────────────────────────────
//
// Reutiliza el mismo `Login`, el mismo cliente de Supabase y las mismas
// pantallas `Plataforma` / `PlataformaVinicola` que ya existían desde 0.42.
// Lo único propio es el guardia —porque el de vinícola exige membresía y el
// superusuario no debe tener ninguna— y este armazón.
//
// ── LO QUE ESTA CONSOLA NO PUEDE HACER ─────────────────────────────────────
//
// Entrar a los datos de una vinícola. No hay pestaña de clientes, ni de
// remisiones, ni de productos, y no es una omisión de esta pantalla: la RLS no
// se lo permitiría aunque la hubiera, porque un superusuario no tiene
// membresía y `mis_tenants()` le devuelve vacío. Para dar una demostración
// existe «Ver como», que queda firmado en la bitácora.
// ═══════════════════════════════════════════════════════════════════════════

import React from "react";
import { GuardiaPlataforma, Cintillo } from "./auth/GuardiaPlataforma.jsx";
import { Plataforma } from "./ui/Plataforma.jsx";
import { salir } from "./auth/sesion.js";
import { APP_VERSION } from "./config/semilla.js";

export function PlataformaApp() {
  return (
    <GuardiaPlataforma>
      {({ sesion }) => (
        <div style={{ minHeight: "100vh", background: "#0a0a0a", color: "#e8e0d4",
                      fontFamily: "'DM Sans', system-ui, sans-serif" }}>
          <Cintillo />

          <header style={{ display: "flex", alignItems: "center", gap: 12,
                           flexWrap: "wrap", padding: "14px clamp(12px, 4vw, 28px)",
                           borderBottom: "1px solid #1a1a1a" }}>
            <div style={{ flex: 1, minWidth: 180 }}>
              <div style={{ fontSize: 15, fontWeight: 600, letterSpacing: 0.5 }}>
                🌐 Administración de plataforma
              </div>
              <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>
                Administra vinícolas. No opera dentro de ninguna.
              </div>
            </div>
            <div style={{ fontSize: 11, color: "#666", textAlign: "right" }}>
              <div>{sesion?.user?.email}</div>
              <div style={{ color: "#444" }}>v{APP_VERSION}</div>
            </div>
            <button onClick={() => salir()}
              style={{ padding: "7px 14px", borderRadius: 7, border: "1px solid #333",
                       background: "#141414", color: "#999", cursor: "pointer", fontSize: 12 }}>
              Salir
            </button>
          </header>

          <main style={{ padding: "clamp(14px, 4vw, 28px)", maxWidth: 1200, margin: "0 auto" }}>
            <Plataforma />
          </main>
        </div>
      )}
    </GuardiaPlataforma>
  );
}
